const list = {
  // =================================================================================================================
  components () {
    return [
      {'component': 'search-start-end', label: '작성일', value:'date', query:{'ss':'startDate', 'ee':'endDate'}, options:{}},
      {'component': 'search-column-keyword', label: '검색조건', value:'column', query:{'ck_t':'head', 'ck_k':'keyword'},
        options: { hiddenList: ['작성일']}},
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  검색일
    if (search.date) {
      conditions.push({key: 'created_at', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'created_at', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "수립연도",
        "key": "body.establishInfo.year"
      },
      {
        "name": "시설종류",
        "key": "body.establishInfo.type"
      },
      {
        "name": "시설명",
        "key": "body.establishInfo.fields[%].field_name",
        "style": { maxWidth: '400px' },
      },
      {
        "name": "관리방법",
        "key": "body.establishInfo.managementMethod"
      },
      {
        "name": "소관부서",
        "key": "body.establishInfo.taskDepartment"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      },
      {
        "name": "작성일",
        "key": "created_at"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0: return func.getContent(value).establishInfo.year
        case 1: return func.getContent(value).establishInfo.type
        case 2: {
          if (func.getContent(value).establishInfo && func.getContent(value).establishInfo.fields) {
            return func.getContent(value).establishInfo.fields.map(e => e.field_name).join(', ')
          }
          return ''
        }
        case 3: return func.getContent(value).establishInfo.managementMethod
        case 4: return func.getContent(value).establishInfo.taskDepartment
        case 5: return func.getContent(value).stdInfo.writer_name
        case 6: return func.getCreatedDate(value.created_at)
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
